import { create } from "zustand";
import { RolePermissions, rolesObjType } from "../types/api";

interface PermissionState {
  permissions: RolePermissions;
  setPermissions: (permissions: rolesObjType["permissions"]) => void;
  clearPermissions: () => void;
}

export const usePermissionStore = create<PermissionState>((set) => ({
  permissions: {},
  setPermissions: (rawPermissions) => {
  if (!rawPermissions) return;
  const normalizedPermissions: RolePermissions = Object.keys(rawPermissions).reduce(
    (acc, key) => {
      const actions = rawPermissions[key];
      if (actions instanceof Set) {
        acc[key] = actions;
      } else if (Array.isArray(actions)) {
        acc[key] = new Set(actions);
      } else {
        acc[key] = new Set();
        console.warn(`Permissions for key '${key}' are not an array or set. Assigned empty Set.`);
      }
      return acc;
    },
    {} as RolePermissions
  );
  set({ permissions: normalizedPermissions });
},
  clearPermissions: () => set({ permissions: {} }),
}));
